import type { AddressSuggestion } from '@@partner:types:app'
import type { ChangeEvent } from 'react-autosuggest'
import type { SyntheticEvent } from 'react'

import React, { useState, useEffect } from 'react'
import { useDebounce } from 'use-debounce'
import useAddressSuggestions from '@@partner:helpers/hooks/useAddressSuggestions'

import Autosuggest from 'react-autosuggest'

import { ADDRESS_SUGGESTION_DEBOUNCE_TIMEOUT } from '@@partner:config'

import theme from './AddressAutoSuggest.module.css'

const getSuggestionValue = (suggestion: AddressSuggestion) =>
  suggestion?.value ?? ''
const renderSuggestion = (suggestion: AddressSuggestion) => suggestion.value

// todo: Make AddressInput compatible with this
const renderDefaultInput = (props: any) => {
  return <input {...props} />
}

export type AddressAutosuggestProps =
  | {
      value: string
      validate?: (arg: string) => boolean
      onChange: (props: any) => void
      renderInput: (props: any) => JSX.Element
      onSuggestionSelected: (
        event: React.FormEvent<any>,
        data: AddressSuggestion
      ) => void
      onReset?: () => void
      inputProps: Record<string, any>
    }
  | Record<string, any>

export default function AddressAutosuggest ({
  value,
  validate,
  onChange,
  renderInput = renderDefaultInput,
  onSuggestionSelected,
  onReset,
  inputProps: ip,
  ...rest
}: AddressAutosuggestProps) {
  const [ inputValue, setInputValue ] = useState<string>(value ?? '')
  const [ debouncedValue ] = useDebounce(
    inputValue,
    ADDRESS_SUGGESTION_DEBOUNCE_TIMEOUT
  )
  const { suggestions, clearSuggestions } =
    useAddressSuggestions(debouncedValue)

  const inputProps = {
    ...rest,
    ...ip,
    autoComplete: 'new-password', // hack to disable autofill
    value: inputValue,
    onChange: (e: SyntheticEvent<any>, { newValue, method }: ChangeEvent) => {
      e.preventDefault()

      if (method === 'type' && newValue.length === 0) {
        onReset?.()
      }

      if (![ 'up', 'down' ].includes(method)) {
        setInputValue(newValue)
        if (validate?.(newValue)) {
          onChange?.(newValue)
        }
      }
    }
  }

  useEffect(() => {
    setInputValue(value)
  }, [ value ])

  return (
    <Autosuggest
      theme={theme}
      suggestions={suggestions}
      highlightFirstSuggestion={true}
      onSuggestionSelected={onSuggestionSelected}
      onSuggestionsFetchRequested={() => suggestions}
      onSuggestionsClearRequested={() => clearSuggestions}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      inputProps={inputProps}
      renderInputComponent={renderInput}
    />
  )
}
